export class SellerDTO{
    sellerId: string;
    sellerDocument: string;
    online: boolean = true;

    constructor(sellerId: string, sellerDocument: string){
        this.sellerId = sellerId;
        this.sellerDocument = sellerDocument;
    }
}